import _ from 'lodash';

import { config } from '../../configuration';
import defaultImage from '~images/ei_tuotekuvaa.jpg';

export const webshopBasePath = '/palvelut/tuotteet';

// eslint-disable-next-line import/prefer-default-export
export const formatPrice = price => {
  if (!price) return 'Virheellinen hinta';

  // This could probably be optimized quite a bit
  const str = price.toString();
  const arr = str.split('');

  while (arr.length < 3) {
    arr.unshift('0');
  }

  arr.splice(arr.length - 2, 0, ',');
  arr.push('€');

  return arr.join('');
};

export const formatDeliveryTime = days => {
  if (days === 0) return 'Saman päivän aikana';
  if (!days) return 'Virheellinen toimitusaika';

  if (days < 7) return `${days} pv`;

  const remainder = days % 7;
  const weeks = (days - remainder) / 7;

  if (remainder === 0) {
    return `${weeks} vk`;
  }

  return `${weeks}-${weeks + 1} vk`;
};

export const formatPackageSize = item => {
  if (!item) return '/ ei pakkauskokoa';
  let { baseUnit, saleUnit, saleUnitMultiplier } = item;

  if (typeof baseUnit !== 'string') {
    return '/ virheellinen yksikkö';
  }

  baseUnit = baseUnit.toLowerCase();
  saleUnit = saleUnit.toLowerCase();
  if (!saleUnitMultiplier) {
    saleUnitMultiplier = 'tuntematon määrä';
  }

  if (saleUnit === baseUnit) {
    return `/${saleUnitMultiplier} ${baseUnit}`;
  }
  return `/${saleUnit} (${saleUnitMultiplier} ${baseUnit})`;
};

export const getImageUrl = path => {
  // Some items don't have an image URL at all
  if (!path) {
    return defaultImage;
  }

  if (process.env.DEBUG) {
    const filename = _.last(path.split('/'));
    return `https://procurementtest.logiacloud.fi/Tuomi/kuvapankki/${filename}`;
  }

  // Proxy for prod and QA
  return `${config.protocol || 'http'}://${
    config.hostname || window.location.host
  }/palvelut/${path}`;
};

export const ITEMS_PER_PAGE = 10;
